import Box from "@mui/material/Box";
import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { TroncRow } from "../../../models/tronc";
import TroncMobileCard from "./TroncMobileCard";
import DetailsMobileTronc from "./DetailsMobileTronc";

interface TroncMobileContainerProps {
    rows: TroncRow[];
    currency: string
}

const TroncMobileContainer = ({ rows,  currency }: TroncMobileContainerProps) => {
    const [detailsModalOpen, setDetailsModalOpen] = useState<boolean>(false);

    const [currentRow, setCurrentRow] = useState<TroncRow>();

    const onClose = () => {
        setDetailsModalOpen(false);
    }

    const handleClick = (event: React.MouseEvent<unknown>, row: TroncRow) => {
        setCurrentRow(row)
        setDetailsModalOpen(true)
    }

    return (
        <>
            {rows.map((row, index) => {
                const key = `${row.staffId}`;
                const isLastRow = index === rows.length - 1;

                return (
                    <Box key={`${key}-outer`}>
                        <Box
                            key={`${key}`}
                            onClick={(event) => handleClick(event, row)}
                        >
                            <TroncMobileCard
                                currency={currency}
                                isLastRow={isLastRow}
                                row={row}
                                labelId={row.staffId}
                            />
                        </Box>
                    </Box>
                );
            })}

            <Modal
                sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}
                open={detailsModalOpen}
            >
                <DetailsMobileTronc
                    onClose={onClose}
                    rows={currentRow}
                    currency={currency}
                />
            </Modal>
        </>
    );

}

export default TroncMobileContainer;
